import React, { useState } from "react";
import Layout from "../../../components/layout/Layout";
import {
  Link,
  useParams,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { ChevronLeftIcon } from "@heroicons/react/solid";
// import useGet from "../../../hooks/read/useGet";
// import SchemeSwitcher from "../components/SchemeSwitcher";
import EmployeeSalaryList from "./EmployeeSalaryList";
import EmployeeCTCDetail from "./EmployeeCTCDetail";

const SingleEmployeeSalary = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();

  // New Scheme is the only active scheme.
  // const [selectedScheme, setSelectedScheme] = useState(
  //   searchParams.get("scheme") || "old"
  // );
  const [selectedScheme] = useState("new");

  // Fetch salary structures list (only needed by the scheme switcher)
  // const { list: structureListReq } = useGet({
  //   url: "salary-structure/list",
  //   initialData: {
  //     page_number: 0,
  //     limit: 50,
  //     search_query: "",
  //   },
  // });

  // const structureList = structureListReq?.data?.data || [];

  // const handleSchemeChange = (slug) => {
  //   setSelectedScheme(slug);
  //   const nextParams = new URLSearchParams(searchParams);
  //   nextParams.set("scheme", slug);
  //   setSearchParams(nextParams, { replace: true });
  // };

  const changeType = (type) => {
    const nextParams = new URLSearchParams(searchParams);
    nextParams.set("type", type);
    setSearchParams(nextParams, { replace: true });
  };

  return (
    <Layout>
      <div className="px-4 py-4 flex justify-between sticky bg-white top-16 shadow-lg z-40">
        <div className="flex items-center space-x-4">
          <button
            onClick={() => navigate(-1, { replace: true })}
            className="flex items-center hover:underline"
          >
            <ChevronLeftIcon className="w-6 h-6" />
            <span className="font-semibold">Back</span>
          </button>
        </div>
        {searchParams.get("mode") !== "resigned" && (
          <Link
            to={`/employee-salary-create/${id}?scheme=${selectedScheme}`}
            className="px-5 py-2 bg-yellow-300 rounded font-semibold"
          >
            Add Salary Details
          </Link>
        )}
      </div>

      <div className="flex flex-col md:flex-row md:items-center justify-between px-5 border-b border-gray-200 mt-6 mx-5">
        <ul className="flex items-center space-x-6 text-gray-600">
          <li
            className={`${
              (searchParams.get("type") === "current_type" ||
                !searchParams.get("type")) &&
              "active"
            }`}
          >
            <button onClick={() => changeType("current_type")}>
              Current CTC Details
            </button>
          </li>
          <li
            className={`${
              searchParams.get("type") === "previous_type" && "active"
            }`}
          >
            <button onClick={() => changeType("previous_type")}>
              Previous CTC Details
            </button>
          </li>
        </ul>

        {/* Scheme Switcher - hidden, New Scheme is the only active scheme */}
        {/* <SchemeSwitcher
          structureList={structureList}
          selectedScheme={selectedScheme}
          handleSchemeChange={handleSchemeChange}
        /> */}
      </div>

      {(searchParams.get("type") === "current_type" ||
        !searchParams.get("type")) && (
        <EmployeeCTCDetail
          key={selectedScheme}
          scheme_type={selectedScheme}
        />
      )}
      {searchParams.get("type") === "previous_type" && (
        <EmployeeSalaryList
          key={selectedScheme}
          scheme_type={selectedScheme}
        />
      )}
    </Layout>
  );
};

export default SingleEmployeeSalary;
